import React from "react";
import Icon from "./../../images/ArrowLongWhite.svg";

const TechinalSpecificationMorphos = () => {
  const array = [
    {
      head: "Synth voice Features",
      sub: [
        {
          key: "",
          message:
            "Fully analog signal path\n2x analog oscillators\nContinuously variable waveform\nThru-zero frequency modulation\nSoft-sync\n",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Modulation Features",
      sub: [
        {
          key: "Controls",
          message: "8x dedicated ping envelopes 8x dedicated modulator",
          flag: true
        },
        {
          key: "Modulator",
          message:
            "4 waveforms\nType settings : Free/Synced/Audio-Rate\nAudio-Rate anti-aliased, quantized to OSC1\nFree from 0.1 to 80 seconds",
          flag: true
        },
        {
          key: "Envelope",
          message: "Decay segment from 10us to 20s",
          flag: true
        }
      ]
    },

    {
      head: "Memory Storage",
      sub: [
        {
          key: "",
          message: "4 banks\n3 layers per bank\n4 presets per layer",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },

    {
      head: "Outputs",
      sub: [
        {
          key: "Eurorack level audio outputs",

          message: "Output level: 10Vpp maximum\nOutput impedance: 1000 Ohm",
          flag: true
        },
        {
          key: "CV outputs",
          message:
            "Voltage range: -5V/+5V\n1V/oct resolution : 3 cents of a semitone",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Electrical Specification",
      sub: [
        {
          key: "",
          message: "+12V: 460mA\n-12V: 90mA\n+5V: 0mA",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Physical Specifications",
      sub: [
        {
          key: "",
          message: "Width: 28HP\nHeight: 3U\nDepth: 25mm",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Warranty",
      sub: [
        {
          key: "",
          message: "2-year Norand warranty",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    }
  ];
  return (
    <>
      <div className="mainTechSpec">
        <div className="technicalSpecHeader">
          <img src={Icon} alt="" className="dropArrowTech" />

          <p className="txtTechSpec"> Technical Specifications</p>
        </div>
        {array.map((item, index) => {
          return (
            <div className="mainTechDetailPart" key={index}>
              <div className="topLineWhite"></div>
              <div className="textTechSpecDetailM">
                <p className="firstTxtTechSpec">{item.head}</p>
                <div className="w100Main">
                  {item.sub.map((data, i) => {
                    return (
                      <div
                        key={i}
                        className={data.flag === true ? "txtPad" : "none"}
                      >
                        <div className="pTopMediumTxt">
                          <p className="mediumTextTech">{data.key}</p>
                        </div>
                        <div className="pTopEndTxt">
                          <p className="txtEndTechSpec">{data.message}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default TechinalSpecificationMorphos;
